if ($('#app-form-tv-ranker-station').length) {

  /*  form_validator('#app-form-tv-ranker-station',
        {
            form_market: {
                required: true
            },
            form_references: {
                required: true,
            },
            form_dayparts: {
                required: true,
            },
            form_stations: {
                required: true,
            },

        },
        {
            form_market: "Please select a Market.",
            form_references: "Please select at least one Reference Book.",
            form_dayparts: "Please select at least one Daypart.",

            form_stations: "Please select at least one Station.",
        }
    );*/



    $('#dayparts').multiSelect($.extend({}, {selectableOptgroup: true}, searchableMultiSelectDef));
    $('#projection').datepicker({minViewMode: 'months', format: 'MM yyyy'});
    $('#stations').multiSelect(searchableMultiSelectDef);

    var playback_types = {
        'LPM': {
            'LO': 'Live Only',
            'LS': 'Live Plus Same Day',
            'L3': 'Live Plus 3',
            'L7': 'Live Plus 7'
        },
        'SRM': {
            'LS': 'Live Plus Same Day',
            'L3': 'Live Plus 3',
            'L7': 'Live Plus 7'
        },
        'CRM': {
            'LS': 'Live Plus Same Day',
            'L3': 'Live Plus 3',
            'L7': 'Live Plus 7'
        },
        'DIA': {
            'L1': 'Live Plus 1'
        }
    };

    var playback_types_all = {
        'LO': 'Live Only',
        'LS': 'Live Plus Same Day',
        'L3': 'Live Plus 3',
        'L7': 'Live Plus 7',
        'L1': 'Live Plus 1'
    };


    var form_markets;
    var form_books;
    var form_curr_market;
    var form_curr_hut;
    var form_curr_share;
    var form_curr_references;
    var form_curr_stations;
    var form_curr_dayparts;



    $(document).ready(function(){
        demos = collect(demos);
        show_loader();
        $.ajax({
            type: "GET",
            url: '/ratings/tv/local/markets',
            dataType: 'json',
            success: function (data) {
                var input = $('#form_market');
                data = collect(data).sortBy('name')/*.keyBy('dma')*/.all();
                console.log("markets");
                console.log(data);
                input.append('<option value=""></option>');
                $.each(data, function (index, value) {
                    if(editing == true)
                    {
                        var se='';
                        if(edit['market'] === value['dma'])
                            se= 'selected';
                        var aux = se !== '' ? 'selected' : '';
                        input.append('<option  '+ aux +' value="' + value['dma'] + '">' + value['name'] + '</option>');
                    }
                    else
                    input.append('<option value="' + value['dma'] + '">' + value['name'] + '</option>');
                });
                data = collect(data).sortBy('name').keyBy('dma').all();

                form_markets = data;


                input.select2({
                    placeholder: "Select one...",
                    minimumResultsForSearch: 10
                }).on('select2:select', function (evt) {
                    tvRankerOnMarketChange();
                    tvRankerFormReset(1);
                });

                $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")

                $('#primary_demo_ids').select2({
                    placeholder: "...",
                    minimumResultsForSearch: 10
                }).bind('select2:select', function () {
                    $(this).closest('.tv-select-demo-container').find('.demo_name')
                        .val($(this).find('option[value="' + $(this).val() + '"]').html());
                });

                $('#secondary_demo_ids').select2({
                    placeholder: "...",
                    minimumResultsForSearch: 10
                }).bind('select2:select', function () {
                    $(this).closest('.tv-select-demo-container').find('.demo_name')
                        .val($(this).find('option[value="' + $(this).val() + '"]').html());
                });

                $('#form_playback_type').select2({
                    placeholder: "Choose a Market..",
                    minimumResultsForSearch: 10
                });

                $('#form_share').select2({
                    placeholder: "Choose a Data Stream..",
                    minimumResultsForSearch: 10,
                    'allowClear': true
                });

                $('#form_hut').select2({
                    placeholder: "Choose a Data Stream..",
                    minimumResultsForSearch: 10,
                    'allowClear': true
                });
                $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")

                $('#form_dayparts').multiSelect({
                    selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                    selectionHeader: "<div style='height: 38px;'><label>Selected</label></div>",
                    afterInit: function(ms){
                        var that = this,
                            $selectableSearch = that.$selectableUl.prev(),
                            selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                        that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                            .on('keydown', function(e){
                                if (e.which === 40){
                                    that.$selectableUl.focus();
                                    return false;
                                }
                            });
                    },
                    afterSelect: function(values){
                        this.qs1.cache();

                        form_curr_dayparts = this.$element.val();
                        if(this.$element.val().length <= 15){
                            tvRankerValidate();
                        }else{
                            this.$element.multiSelect('deselect', values);
                            form_curr_dayparts = this.$element.val();

                            swal({
                                    title: "Warning",
                                    text: "The max number is 15 ...",
                                    type: "warning",
                                    showCancelButton: true,
                                    confirmButtonClass: "btn-danger",
                                    confirmButtonText: "OK",
                                    cancelButtonText: "Close",
                                    closeOnConfirm: true,
                                    closeOnCancel: true
                                },
                                function (isConfirm) {

                                });
                        }

                        if(form_curr_dayparts.length < 15){
                            this.$element.closest('.form_dayparts_container').find('.select-count').html('(' + form_curr_dayparts.length + ' / 15)').removeClass('text-warning').addClass('text-muted');
                        }else{
                            this.$element.closest('.form_dayparts_container').find('.select-count').html('(' + form_curr_dayparts.length + ' / 15)').removeClass('text-muted').addClass('text-warning');
                        }
                    },
                    afterDeselect: function(values){
                        this.qs1.cache();

                        form_curr_dayparts = this.$element.val();
                        tvRankerValidate();

                        this.$element.closest('.form_dayparts_container').find('.select-count').html('(' + form_curr_dayparts.length + ' / 15)').removeClass('text-warning').addClass('text-muted');
                    }
                });

                $('#form_projection').datepicker(
                    {
                        minViewMode: 'months',
                        format: 'MM yyyy',
                        orientation: 'bottom'
                    }).on('changeDate', function(){
                    tvRankerValidate();
                });

                $('#form_stations').multiSelect(searchableMultiSelectDef);

                $('#form_references').multiSelect(searchableMultiSelectDef);

                $('#form_reset').bind('click', function(){
                    tvRankerFormReset();
                });

                if(editing == true && pepe=== true){
                    form_curr_market = form_markets[$('#form_market').val()];
                    if(edit['primary_demo_type']=='m') {
                        $('#primary_demo_type_m').prop('checked', true);
                        $('.demo_name').val(edit['primary_demo_name']);
                        r=1;
                        $('#primary_demo_type_m').trigger("change");

                    }
                    if(edit['primary_demo_type']=='f'){
                        $('#primary_demo_type_f').prop('checked', true);
                        $('.demo_name').val(edit['primary_demo_name']);
                        r=1;
                        $('#primary_demo_type_f').trigger("change");

                    }
                    if(edit['primary_demo_type']=='p') {
                        $('#primary_demo_type_p').prop('checked', true);
                        $('.demo_name').val(edit['primary_demo_name']);
                        r=1;
                        $('#primary_demo_type_p').trigger("change");


                    }
                    if(edit['primary_demo_type']=='hh') {
                        $('#primary_demo_type_hh').prop('checked', true);
                        $('.demo_name').val(edit['primary_demo_name']);
                        r=1;
                        $('#primary_demo_type_hh').trigger("change");


                    }

                    if(edit['secondary_demo_type']=='m') {

                        $('#secondary_demo_type_m').prop('checked', true);
                        $('.sec_demo_name').val(edit['secondary_demo_name']);
                        r=2;
                        $('#secondary_demo_type_m').trigger("change");

                    }
                    if(edit['secondary_demo_type']=='f'){
                        $('#secondary_demo_type_f').prop('checked', true);
                        $('.sec_demo_name').val(edit['secondary_demo_name']);
                        r=2;
                        $('#secondary_demo_type_f').trigger("change");

                    }
                    if(edit['secondary_demo_type']=='p') {
                        $('#secondary_demo_type_p').prop('checked', true);
                        $('.sec_demo_name').val(edit['secondary_demo_name']);
                        r=2;
                        $('#secondary_demo_type_p').trigger("change");


                    }
                    if(edit['secondary_demo_type']=='hh') {
                        $('#secondary_demo_type_hh').prop('checked', true);
                        $('.sec_demo_name').val(edit['secondary_demo_name']);
                        r=2;
                        $('#secondary_demo_type_hh').trigger("change");


                    }
                    tvRankerOnMarketChange();

                }

                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
                hide_loader();
            }
        });
    });

    var tvRankerOnMarketChange = function(){
        show_loader();
      //  alert('entre al marketchange ' +pepe );

        form_curr_market = form_markets[$('#form_market').val()];
        /*form_playbacks = playback_types[form_curr_market['type']];

        var input = $('#form_playback_type');

        input.attr('disabled', null);

        if((editing== true && pepe== false) || (editing==false))
       input.data('select2').destroy();

        input.html('').append('<option value=""></option>');

        $.each(form_playbacks, function (index, value) {
            if(editing== true && pepe== true) {
                var se = 'ex';

                if (index == edit['playback_type'])
                    se = 'selected';
                var aux = se !== 'ex' ? 'selected' : '';
                input.append('<option  ' + aux + ' value="' + index + '">' + value + '</option>')
            }
            else
                input.append('<option value="' + index + '">' + value + '</option>')

        });

        input.select2({
            placeholder: "Select...",
            minimumResultsForSearch: 10
        });
        $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")


        input.bind('change', function () {
            tvRankerOnPlaybackChange();
            tvRankerValidate();
        });
        */

        $.ajax({
            type: "GET",
            url: '/ratings/tv/local/monthly/allbooks/?dma=' + form_curr_market['dma'],
            dataType: 'json',
            success: function (data) {
                console.log("books");
                //console.log(data);
                console.log(collect(data).keyBy('playback_type').all());
                var form_playbacks = collect(data).sortBy('name').keyBy('playback_type').all();
                var input = $('#form_playback_type');
                input.attr('disabled', null);
                if((editing== true && pepe== false) || (editing==false))
                    input.data('select2').destroy();
                input.html('').append('<option value=""></option>');
                $.each(form_playbacks, function (index, value) {
                    if(editing == true && pepe == true) {
                        var se = 'ex';
                        if (index == edit['playback_type'])
                            se = 'selected';
                        var aux = se !== 'ex' ? 'selected' : '';
                        input.append('<option  ' + aux + ' value="' + index + '">' + playback_types_all[index] + '</option>')
                    }
                    else
                        input.append('<option value="' + index + '">' + playback_types_all[index] + '</option>')
                });
                input.select2({
                    placeholder: "Select...",
                    minimumResultsForSearch: 10
                });
                $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")


                input.bind('change', function () {
                    tvRankerOnPlaybackChange();
                    tvRankerValidate();
                });

                input = $('#form_references');

                input.attr('disabled', null);


                input.multiSelect('destroy');

                input.html('').append('');
                $.each(data, function (index, value) {
                    if(editing== true && pepe== true) {
                        var se = 'ex';
                        for (var i in selected_books) {

                            if (value['id'] == selected_books[i])
                                se = 'selected';

                        }
                        var aux = se !== 'ex' ? 'selected' : '';


                        input.append('<option ' + aux +' value="' + value['id'] + '">' + value['name'] + '; ' + value['playback_type'] + ((value['service'] === "NSIX") ? " Impact Data" : "") + '</option>');
                    }
                    else
                        input.append('<option value="' + value['id'] + '">' + value['name'] + '; ' + value['playback_type'] + ((value['service'] === "NSIX") ? " Impact Data" : "") + '</option>');
                });

                input.multiSelect({
                    selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                    selectionHeader: "<div style='height: 38px;'><label>Selected</label></div>",
                    afterInit: function(ms){
                        var that = this,
                            $selectableSearch = that.$selectableUl.prev(),
                            selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                        that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                            .on('keydown', function(e){
                                if (e.which === 40){
                                    that.$selectableUl.focus();
                                    return false;
                                }
                            });
                        if(pepe== true && editing==true)
                        {
                            tvRankerOnPlaybackChange();
                        }
                    },
                    afterSelect: function(values){
                        this.qs1.cache();

                        form_curr_references = this.$element.val();
                        if(this.$element.val().length <= 4){
                            if ($("#top_x").is(':checked'))
                                tvRankerOnBooksChange(false, 1);
                            else
                            tvRankerOnBooksChange(false, 0);
                        }else{
                            this.$element.multiSelect('deselect', values);
                            form_curr_references = this.$element.val();

                            swal({
                                    title: "Warning",
                                    text: "The max number is 4 ...",
                                    type: "warning",
                                    showCancelButton: true,
                                    confirmButtonClass: "btn-danger",
                                    confirmButtonText: "OK",
                                    cancelButtonText: "Close",
                                    closeOnConfirm: true,
                                    closeOnCancel: true
                                },
                                function (isConfirm) {

                                });
                        }

                        if(form_curr_references.length < 4){
                            this.$element.closest('.form_references_container').find('.select-count').html('(' + form_curr_references.length + ' / 4)').removeClass('text-warning').addClass('text-muted');
                        }else{
                            this.$element.closest('.form_references_container').find('.select-count').html('(' + form_curr_references.length + ' / 4)').removeClass('text-muted').addClass('text-warning');
                        }
                        tvRankerValidate();
                    },
                    afterDeselect: function(values){
                        this.qs1.cache();
//                                tvRankerOnBooksChange();
                        form_curr_references = this.$element.val();
                        if(form_curr_references.length > 0){
                            if ($("#top_x").is(':checked'))
                                tvRankerOnBooksChange(false, 1);
                            else
                                tvRankerOnBooksChange(false, 0);


                        }else{
                            checkResetBooks();
                        }

                        tvRankerValidate();

                        this.$element.closest('.form_references_container').find('.select-count').html('(' + form_curr_references.length + ' / 4)').removeClass('text-warning').addClass('text-muted');
                    }
                });

                input.closest('.form_references_container').removeClass('hidden');
                input.closest('.form_references_container').parent().find('.help-text').addClass('hidden');


                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
            }
        });
    };

    var tvRankerOnPlaybackChange = function(){
       // alert('entre al playback ' +pepe );

        form_curr_playback = $('#form_playback_type').val();

        show_loader();
        $.ajax({
            type: "GET",
            url: '/ratings/tv/local/monthly/allbooks/?dma=' + form_curr_market['dma'] + '&playback=' + form_curr_playback,
            dataType: 'json',
            success: function (data) {
                form_books = data;
                var input = $('#form_hut');
                input.attr('disabled', null);
                input.data('select2').destroy();
                input.html('').append('<option value=""></option>');
                var dates_ordered= data
                var OrdDates= Object.entries(dates_ordered).sort((a,b) => (moment(a[1].start) > moment(b[1].start)) ? 1 : ((moment(b[1].start) > moment(a[1].start)) ? -1 : 0));

                var cont = OrdDates.length - 1;
                while(cont >= 0){
                    var value= OrdDates[cont][1];
                    if((editing=== true )) {
                        var se = 'ex';
                        if (value['id'] == edit['hut'])
                                 se = 'selected';
                        var aux = se !== 'ex' ? 'selected' : '';
                        input.append('<option '+ aux +'  value="' + value['id'] + '">' + value['name'] + ((value['service'] === "NSIX") ? " Impact Data" : "") + '</option>')
                    }
                    else
                        input.append('<option value="' + value['id'] + '">' + value['name'] + ((value['service'] === "NSIX") ? " Impact Data" : "") + '</option>')
                    cont--;
                }

                if(editing== true && pepe=== true)
                    contador++;
                // $.each(data, function (index, value) {
                //     if((editing=== true )) {
                //         var se = 'ex';
                //
                //             if (value['id'] == edit['hut'])
                //                 se = 'selected';
                //
                //         var aux = se !== 'ex' ? 'selected' : '';
                //         input.append('<option '+ aux +'  value="' + value['id'] + '">' + value['name'] + ((value['service'] === "NSIX") ? " Impact Data" : "") + '</option>')
                //     }
                //     else {
                //         input.append('<option value="' + value['id'] + '">' + value['name'] + ((value['service'] === "NSIX") ? " Impact Data" : "") + '</option>')
                //     }
                //
                // });
                console.log(input.html());
                input.select2({
                    placeholder: "Select...",
                    minimumResultsForSearch: 10,
                    'allowClear': true
                });
                console.log(input.html());
                $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")

                input.bind('change', function () {
                    if ($("#top_x").is(':checked'))
                        tvRankerOnBooksChange(false, 1);
                    else
                        tvRankerOnBooksChange(false, 0);
                    checkResetBooks();
                    tvRankerValidate();
                });

                input = $('#form_share');

                input.attr('disabled', null);

                input.data('select2').destroy();

                input.html('').append('<option value=""></option>');
                var cont = OrdDates.length - 1;
                while(cont >= 0){
                    var value= OrdDates[cont][1];
                    if((editing=== true )) {
                        var se = 'ex';
                        if (value['id'] == edit['share'])
                            se = 'selected';
                        var aux = se !== 'ex' ? 'selected' : '';
                        input.append('<option '+ aux +'  value="' + value['id'] + '">' + value['name'] + ((value['service'] === "NSIX") ? " Impact Data" : "") + '</option>')
                    }
                    else
                        input.append('<option value="' + value['id'] + '">' + value['name'] + ((value['service'] === "NSIX") ? " Impact Data" : "") + '</option>')
                    cont--;
                }

                // $.each(data, function (index, value) {
                //
                //     if(editing== true) {
                //         var se = 'ex';
                //
                //         if (value['id'] == edit['share'])
                //             se = 'selected';
                //
                //         var aux = se !== 'ex' ? 'selected' : '';
                //         input.append('<option '+ aux +'  value="' + value['id'] + '">' + value['name'] + ((value['service'] === "NSIX") ? " Impact Data" : "") + '</option>')
                //     }
                //     else
                //
                //     input.append('<option value="' + value['id'] + '">' + value['name'] + ((value['service'] === "NSIX") ? " Impact Data" : "") + '</option>')
                // });

                input.select2({
                    placeholder: "Select...",
                    minimumResultsForSearch: 10,
                    'allowClear': true
                });
                $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")

                input.bind('change', function () {
                    if ($("#top_x").is(':checked'))
                        tvRankerOnBooksChange(false, 1);
                    else
                        tvRankerOnBooksChange(false, 0);

                    checkResetBooks();
                });

              if(editing==true && pepe== true)
                  tvRankerOnBooksChange(false,2);

             if(editing==false)
                 if ($("#top_x").is(':checked'))
                     tvRankerOnBooksChange(false, 1);
                 else
                     tvRankerOnBooksChange(false, 0);

                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
            }
        });
    };


    var tvRankerOnBooksChange = function(esta, top){
       // alert('entre al book change ' +pepe );

        var hut_input = $('#form_hut');
        var share_input = $('#form_share');
        var ref_input = $('#form_references');

        form_curr_hut = hut_input.val();
        form_curr_share = share_input.val();
        form_curr_references = ref_input.val();

        var push = [];
        if((form_curr_hut !== "") && (form_curr_hut !== null)){
            push.push(form_curr_hut);
        }
        if(form_curr_share !== "" && (form_curr_share !== null)){
            push.push(form_curr_share);
        }

        var selected = push.concat(form_curr_references);

        hut_input.find('option').attr('disabled', null);
        share_input.find('option').attr('disabled', null);
        ref_input.find('option').attr('disabled', null);

        $.each(selected, function(index, value){
            /*if(value !== form_curr_hut){
                hut_input.find('option[value="' + value + '"]').attr('disabled', 'disabled');
            }

            if(value !== form_curr_share){
                share_input.find('option[value="' + value + '"]').attr('disabled', 'disabled');
            }*/

            if($.inArray(value, form_curr_references) === -1){
                ref_input.find('option[value="' + value + '"]').attr('disabled', 'disabled');
            }
        });

        ref_input.multiSelect('refresh');


        if(selected.length > 0){
            var parameters = '?';
            $.each(selected, function(index, value){
                parameters += 'books[]=' + value + '&';
            });
            var url = '/ratings/tv/local/monthly/books/distributors/' + parameters;
            show_loader();
            $.ajax({
                type: "GET",
                url: url,
                dataType: 'json',
                success: function (data) {
                    var input = $('#form_stations');
                    var selections = input.val();

                    input.attr('disabled', null);
                    input.multiSelect('destroy');
                    input.html('');

                  if(esta=='borrar')
                         var selections = input.val();

                    var html_broadcast = '';
                    var html_cable = '';

                    $.each(data, function (index, value) {
                        if (value['affil'] !== null) {

                            if(esta=='borrar')
                            {
                                var aux='';

                                html_broadcast = html_broadcast + '<option   '+ aux +' value="' + value['id'] + '">'
                                    + value['name'] + ' (' + value['affil'] + ')</option>';
                            }

                          else  if(esta==true)
                            {
                                console.log('entre al afiliacon selecionar');
                                var aux = 'selected' ;

                                html_broadcast = html_broadcast + '<option  '+ aux +' value="' + value['id'] + '">'
                                    + value['name'] + ' (' + value['affil'] + ')</option>';
                            }


                         else  if(editing== true && pepe=== true) {

                                var se = 'ex';
                                for (var i in selected_stations) {
                                    if (value['id'] == selected_stations[i])
                                        se = 'selected';
                                }
                                var aux = se !== 'ex' ? 'selected' : '';

                                html_broadcast = html_broadcast + '<option  '+ aux +' value="' + value['id'] + '">'
                                    + value['name'] + ' (' + value['affil'] + ')</option>';
                            }
                            else
                            {  html_broadcast = html_broadcast + '<option value="' + value['id'] + '">'
                                    + value['name'] + ' (' + value['affil'] + ')</option>';}
                        } else {

                            if(esta==true)
                            {

                                var aux='selected';
                                html_cable = html_cable + '<option '+ aux +'  value="' + value['id'] + '">' + value['name'] + '</option>';
                            }
                            else if(esta=='borrar')
                            {

                                var aux='';

                                html_cable = html_cable + '<option '+ aux +' value="' + value['id'] + '">' + value['name'] + '</option>';
                            }

                        else if(editing== true && pepe== true) {

                                var se = 'ex';
                                for (var i in selected_stations) {
                                    if (value['id'] == selected_stations[i])
                                        se = 'selected';
                                }
                                var aux = se !== 'ex' ? 'selected' : '';
                                html_cable = html_cable + '<option '+ aux +'  value="' + value['id'] + '">' + value['name'] + '</option>';
                            }
                           else
                               html_cable = html_cable + '<option value="' + value['id'] + '">' + value['name'] + '</option>';
                        }
                    });

                      if(top===1 && ( ($('#form_hut').val() !== null && $('#form_hut').val()!== '') || ($('#form_share').val() !== null && $('#form_share').val() !== '')) ) {
                          var xxx = 'checked';
                          var disa=''
                      }
                      else if(($('#form_hut').val() !== null && $('#form_hut').val()!== '') || ($('#form_share').val() !== null && $('#form_share').val() !== ''))
                      {
                          var xxx='';
                          var disa='';
                      }
                      else
                      {
                          var xxx='';
                          var disa='disabled';
                      }
                    if(editing===true )
                    {
                        if(general['top']==1 && esta !== 'borrar' && top===2) {
                            var xxx = 'checked';
                            var disa = '';
                        }
                    }

                          pepe=false;
                    input.append('<optgroup label="Broadcast">' + html_broadcast + '</optgroup>');
                    input.append('<optgroup label="Cable">' + html_cable + '</optgroup>');

                    $.each(selections, function (index, value) {
                        input.find('option[value="' + value + '"]').attr('selected', 'selected');
                    });

                    input.multiSelect({
                        selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                        selectionHeader: "<div style='height: 38px;' ><input type='button' class='btn btn-primary m-r-5 btn-sm ' value='Select All' id='select_all_sta' >&nbsp;<input type='button' class='btn btn-primary m-r-5 btn-sm ' value='Deselect All' id='deselect_all'> " +
                        " <input id='top_x'  name='top_x' "+ disa+" type='checkbox'  "+ xxx +" >  Top " +
                        " <input type='number' max='0' disabled min='1' id='stations_number' name='stations_number' style='width: 15%' value='1'> </div>",
                        selectAllText: 'Select All',
                        deselectAllText: 'Deselect All',
                        afterInit: function(ms){
                            var that = this,
                                $selectableSearch = that.$selectableUl.prev(),
                                selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                            that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                                .on('keydown', function(e){
                                    if (e.which === 40){
                                        that.$selectableUl.focus();
                                        return false;
                                    }
                                });
                        },
                       /* afterSelect: function(values){
                            this.qs1.cache();

                            form_curr_stations = this.$element.val();
                            if(this.$element.val().length <= 30){
                                tvRankerValidate();
                            }else{
                                this.$element.multiSelect('deselect', values);
                                form_curr_stations = this.$element.val();

                                swal({
                                        title: "The max number is 30 ...",
                                        text: "",
                                        type: "warning",
                                        showCancelButton: true,
                                        confirmButtonClass: "btn-danger",
                                        confirmButtonText: "OK",
                                        cancelButtonText: "Close",
                                        closeOnConfirm: true,
                                        closeOnCancel: true
                                    },
                                    function (isConfirm) {

                                    });
                            }

                            if(form_curr_stations.length < 30){
                                this.$element.closest('.form_dists_container').find('.select-count').html('(' + form_curr_stations.length + ' / 30)').removeClass('text-warning').addClass('text-muted');
                            }else{
                                this.$element.closest('.form_dists_container').find('.select-count').html('(' + form_curr_stations.length + ' / 30)').removeClass('text-muted').addClass('text-warning');
                            }
                        },
                        afterDeselect: function(values){
                            this.qs1.cache();

                            form_curr_stations = this.$element.val();

                            tvRankerValidate();

                            this.$element.closest('.form_dists_container').find('.select-count').html('(' + form_curr_stations.length + ' / 30)').removeClass('text-warning').addClass('text-muted');
                        }*/
                    });


                    $('#form_share').on('change', function () {
                        if( ($('#form_hut').val() !== null && $('#form_hut').val()!== '') || ($('#form_share').val() !== null && $('#form_share').val() !== '') )
                        {

                            $('#top_x').attr('disabled', false);
                        }
                        else
                            $('#top_x').attr('disabled', true);


                    });
                    $('#form_hut').on('change', function () {
                        if( ($('#form_hut').val() !== null && $('#form_hut').val()!== '') || ($('#form_share').val() !== null && $('#form_share').val() !== '') )
                        {

                            $('#top_x').attr('disabled', false);
                        }
                        else
                            $('#top_x').attr('disabled', true);


                    });




                   if(esta===true && (top===1 || top===2)  || $("#top_x").is(':checked'))
                   {
                       var max= $('#form_stations');
                       max= $(max).val().length;
                       if(max > 0)
                           $('#stations_number').attr("max",max);
                       else
                       {
                           $('#stations_number').attr("min",0);
                           $('#stations_number').val(0);
                       }

                       if(editing===true && top===2)
                       $('#stations_number').val(general['stations_number']);

                       $('#top_x').attr('disabled', false);


                       $('#stations_number').attr("disabled", false);
                   }

                    $('#select_all_sta').on('click', function (e) {
                        tvRankerOnBooksChange(true, 0);
                    });

                    $('#deselect_all').on('click', function (e) {
                        tvRankerOnBooksChange('borrar', 0);
                    });


                    $('#top_x').on('change', function () {

                        if ($("#top_x").is(':checked')) {
                            tvRankerOnBooksChange(true, 1);

                        }
                        else {
                            tvRankerOnBooksChange('borrar', 0);
                            $('#stations_number').attr("disabled", true);

                        }

                    });
                    $('#form_stations').on('change', function () {
                        var max= $('#form_stations');
                        max= $(max).val().length;


                        if(max > 0)
                            $('#stations_number').attr("max",max);
                        else
                        {
                            $('#stations_number').attr("min",0);
                            $('#stations_number').val(0);
                        }

                        if ($("#top_x").is(':checked')){
                            if( $('#stations_number').val() > max)
                                $('#stations_number').val(max);

                        }

                    });

                    input.closest('.form_dists_container').removeClass('hidden');
                    input.closest('.form_dists_container').parent().find('.help-text').addClass('hidden');
                    hide_loader();


                },
                error: function (xhr) {
                    ajax_error();
                    hide_loader();
                }
            });
        }
    };


    $('#form_submit').on('click', function (e) {

        var market= $("#form_market option:selected").val();
        var stations= $('#form_stations');

        var daypart= $('#form_dayparts');
        var book= $('#form_references');

        var hut = $('#form_hut');
        var share = $('#form_share');

        hut = hut.val();
        share = share.val();

        var p=false;
        var pp= false;

        if(market !== "")
        {
            if($(book).val().length != 0  || (share !== null && share !== "")|| ( hut !== null  && hut !== "") )
            {
                     if( $(stations).val().length != 0 ) {
                         p = true;
                         pp= true;
                     }
                     else
                         global_notification('warning','Please select at least one Station');
            }
            else
                global_notification('warning','Please select a Book');
        }
        else
            global_notification('warning','Please select a Market');



        if($(daypart).val().length == 0 && p== true)
        {
            pp= false;
            global_notification('warning','Please select at least one Daypart');
        }
        if(pp == true) {

            if (editing == true) {
                $('#saved_report_id').val(general['id']);
                $('#reportable_id').val(edit['id']);
                $('#app-form-tv-ranker-station').attr('action', '/ratings/tv/ranker/station/editar');
                $('#app-form-tv-ranker-station').submit();
            }

            else
                $('#app-form-tv-ranker-station').submit();
        }

    });


    var tvRankerValidate = function(){

       /* var inputs = {
            'market': $('#form_markets'),
            'share': $('#form_share'),
            'hut': $('#form_hut'),
            'proj': $('#form_projection'),
            'references': $('#form_references'),
            'dayparts': $('#form_dayparts'),
            'stations': $('#form_stations')
        };

        var pass = false;
        if((inputs['market'].val().length !== 0))
        {
            $('#market_label').css("display", "block");
        }

        if((inputs['dayparts'].val().length !== 0) && (inputs['stations'].val().length !== 0)){
            if(((inputs['share'].val() !== '') && (inputs['share'].val() !== null)) && ((inputs['hut'].val() !== '') && (inputs['hut'].val() !== null)) && (inputs['proj'].val() !== '')){
                pass = true;
            }else if(inputs['references'].val().length !== 0){
                pass = true;
            }
        }

       var input_submut = $('#form_submit');
      /*  if(pass){
            input_submut.attr('disabled', null);
        }else{
            input_submut.attr('disabled', 'disabled');
        }*/


    };

    var checkResetBooks = function(){
        var inputs = {
            'share': $('#form_share'),
            'hut': $('#form_hut'),
            'references': $('#form_references'),
        };
        if(((inputs['share'].val() === '') || (inputs['share'].val() === null)) && ((inputs['hut'].val() === '') || (inputs['hut'].val() === null)) && (inputs['references'].val().length === 0)){
            tvRankerFormReset(2);
        }
    };

    var tvRankerFormReset = function(step){
        if(typeof step === 'undefined'){
            step = 'all';
        }

        if(step === 'all') {
            var input = $('#form_market');

           input.data('select2').destroy();
            input.unbind('select2:select');

            input.html('').append('<option value=""></option>');
            $.each(form_markets, function (index, value) {
                input.append('<option value="' + index + '">' + value['name'] + '</option>')
            });

            input.attr('disabled', null);
            input.select2({
                placeholder: "Select one...",
                minimumResultsForSearch: 10
            }).on('select2:select', function (evt) {
                tvRankerOnMarketChange();
                tvRankerFormReset(1);
            });
            $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")

            input = $('#form_playback_type');

            input.data('select2').destroy();
            input.unbind('select2:select');
            input.html('');
            input.attr('disabled', 'disabled');
            input.select2({
                placeholder: "Select a market...",
                minimumResultsForSearch: 10
            });
            $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")

            input = $('#form_dayparts');
            input.multiSelect('deselect_all');
            input.closest('.form_dayparts_container').find('.text-default').html('Maximum of Fifteen.<span class="pull-right"><small><span class="select-count text-muted">(0 / 15)</span></small></span>');

            input = $('#form_name').val('');
        }

        if((step < 2) || (step === 'all')) {
            input = $('#form_share');

            input.data('select2').destroy();
            input.unbind('select2:select');
            input.html('');
            input.attr('disabled', 'disabled');
            input.select2({
                placeholder: "Select a data stream...",
                minimumResultsForSearch: 10
            });
            $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")

            input = $('#form_hut');

            input.data('select2').destroy();
            input.unbind('select2:select');
            input.html('');
            input.attr('disabled', 'disabled');
            input.select2({
                placeholder: "Select a data stream...",
                minimumResultsForSearch: 10
            });
            $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")

            input = $('#form_projection');
            input.val('');

            input = $('#form_references');

            input.multiSelect('destroy');
            input.html('');
            input.multiSelect(searchableMultiSelectDef);
            input.closest('.form_references_container').addClass('hidden');
            input.closest('.form_references_container').parent().find('.help-text').removeClass('hidden');
        }

        if((step < 3) || (step === 'all')) {
            input = $('#form_stations');

            input.multiSelect('destroy');
            input.html('');
            input.multiSelect(searchableMultiSelectDef);
            input.closest('.form_dists_container').addClass('hidden');
            input.closest('.form_dists_container').parent().find('.help-text').removeClass('hidden');
        }

        tvRankerValidate();
    };


    $('.tv-select-demo-container input[type="radio"]').on('change', function () {
        var demo_type = $(this).val();
        var select = $($(this).closest('.tv-select-demo-container').find('select')[0]);
        select.html('');
        select.attr('disabled', null);

        if (demo_type === 'hh') {
            select.append('<option value="hh" selected>-</option>');
            $(this).closest('.tv-select-demo-container').find('.demo_name')
                .val('hh');
            select.attr('readonly', 'readonly');
        } else if (demo_type === '') {
            select.append('<option value="" selected>-</option>');
            select.attr('disabled', 'disabled');
        } else if (demo_type === 'p') {
            demos.each(function (item) {
                var ids = "";
                var string = "";
                $.each(item['blocks']['p'], function (index, value) {
                    ids += value.toString() + ',';
                });

                if(editing==true ){
                    if(r===1) {
                        var dn = edit['primary_demo_name'];
                    }
                    if(r===2)
                        var dn= edit['secondary_demo_name'];

                    select.find('option').prop('selected', null);
                     // select.find('option:contains('+ dn +')').prop('selected', 'selected');

                    $.each( select.find('option'), function (index, value){
                        if($(value).text() == dn)
                            $(value).prop('selected', 'selected');
                    });
                }

                if (item['end'] === null) {
                    string = item['start'] + "+";
                } else {
                    string = item['start'] + "-" + item['end'];
                }

                select.append('<option  value="' + ids + '">' + string + '</option>');
            });
        } else {
            demos.each(function (item) {
                if ((item['start'] !== 6) && (item['start'] !== 2)) {
                    var ids = "";
                    var string = "";
                    $.each(item['blocks'][demo_type], function (index, value) {
                        ids += value.toString() + ',';
                    });

                    if(editing==true ) {
                        if(r==1) {
                            var dn = edit['primary_demo_name'];
                        }
                        if(r==2)
                            var dn= edit['secondary_demo_name'];


                        select.find('option').prop('selected', null);
                        //select.find('option:contains('+ dn +')').prop('selected', 'selected');
                        $.each( select.find('option'), function (index, value){
                            if($(value).text() == dn)
                                $(value).prop('selected', 'selected');
                        });
                    }

                    if (item['end'] === null) {
                        string = item['start'] + "+";
                    } else {
                        string = item['start'] + "-" + item['end'];
                    }

                    select.append('<option  value="' + ids + '">' + string + '</option>');
                }
            });

            if (demo_type === 'f') {
                select.append('<option value="ww">WW</option>');
            }
        }
    });
};